<template>
    <div class="nav">
        <div class="nav-lists">
            <div v-for="(item, index) in navList" :key="index" class="nav-item" :class="{ navactive: index === ind }"
                v-on:click="firstClick(item)" v-show="item.isShow && index < 10" @mouseover="cover(item)"
                @mouseleave="leave()">
                {{ item.title }}
                <!-- <div @mouseenter="enter()" @mouseleave="leave()" v-show="isNav" class="nav-down-wrap">
                    <div v-for="(temp, index1) in item.childList" :key="index1" v-on:click.stop="secondClick(temp)"
                        class="down-item">
                        {{ temp.title}}
                        <div class="dian"></div>
                    </div>
                </div> -->
            </div>
            <div class="search">
                <Input v-model="searchText" @on-keyup.enter="search" placeholder="请输入搜索内容" style="width: 120px" />
                <Button @click="search" type="primary">搜索</Button>
            </div>
            <!-- <div class="nav-item" @mouseover="decide()" @mouseleave="clear()" v-show="decide()"
                :class="{ navactive: ind >= 10 }">
                <div class="text"></div>
                <div v-show="isShow" class="nav-down-wraps">
                    <div v-show="item.isShow && index > 9" v-for="(item, index) in navList" :key="index"
                        v-on:click="firstClick(item)" class="down-item">
                        {{ item.title }}
                        <div class="dian"></div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import refreshNav from ".././nav";
import casjump from "../common/casjump";
export default {
    mixins: [casjump],
    components: {},
    data() {
        return {
            navList: [],
            isNav: false,
            list: [],
            ind: 0,
            title: "",
            state: true,
            isShow: false,
            imgLogo: "",
            logoContent: true,
            logoShow: false,
            searchText: "",
            flag: 0,
        };
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.getNav();
                this.getLogo();
                let query1 = this.$route.query;
                //如果为主页的话
                if (this.$route.path === "/home") this.ind = 0;
                //如果为预设的solution组件的话我们更新
                else if (query1.id && this.$route.path === "/home/solution") {
                    let item = this.navList.find((item) => item.id === query1.id);
                    this.ind = item.ordina - 1;
                }
                //此为不关联cms的情况，我们遍历对应两层数组得到ordina，最后进行更新
                else {
                    let arr = [];
                    for (let i = 0; i < this.navList.length; i++) {
                        if (this.navList[i].param) arr.push(this.navList[i]);
                        if (this.navList[i].childList) {
                            for (let j = 0; j < this.navList[i].childList.length; j++) {
                                if (this.navList[i].childList[j].param) arr.push(this.navList[i].childList[j]);
                            }
                        }
                    }
                    let q = arr.find((item) => "/home" + JSON.parse(item.param).route === this.$route.path);
                    if (q.parent) {
                        this.ind = Math.trunc(q.ordina / 100) - 1;
                    } else {
                        this.ind = q.ordina - 1;
                    }
                }
            },
            deep: true,
        },
    },
    async mounted() {
        await this.getNav();
        await this.getLogo();
        let query1 = this.$route.query;
        //和之前watch的部分同理
        if (this.$route.path === "/home") this.ind = 0;
        else if (query1.id && this.$route.path === "/home/solution") {
            let item = this.navList.find((item) => item.id === query1.id);
            this.ind = item.ordina - 1;
        } else {
            let arr = [];
            for (let i = 0; i < this.navList.length; i++) {
                if (this.navList[i].param) arr.push(this.navList[i]);
                if (this.navList[i].childList) {
                    for (let j = 0; j < this.navList[i].childList.length; j++) {
                        if (this.navList[i].childList[j].param) arr.push(this.navList[i].childList[j]);
                    }
                }
            }
            let q = arr.find((item) => "/home" + JSON.parse(item.param).route === this.$route.path);
            if (q.parent) {
                this.ind = Math.trunc(q.ordina / 100) - 1;
            } else {
                this.ind = q.ordina - 1;
            }
        }
    },
    methods: {
        search() {
            if (this.searchText) {
                this.flag++;
                this.$router.push({
                    path: "/home/searchResult",
                    query: {
                        searchText: this.searchText,
                        flag: this.flag,
                    },
                });
            } else {
                this.$Message.info("请输入搜索内容");
            }
        },
        firstClick(item) {
            //如果未关联CMS的话，我们根据对应的param进行跳转
            if (!item.isCMS) {
                let param1 = JSON.parse(item.param);
                if (param1.link) {
                    window.open(param1.link, "_blank");
                } else if (param1.route == "home") {
                    this.$router.push("/" + param1.route);
                } else if (param1.route == "/home") {
                    this.$router.push(param1.route);
                } else {
                    if (!param1.query) this.$router.push("/home" + param1.route);
                    else {
                        this.$router.push({
                            path: "/home" + param1.route,
                            query: param1.query,
                        });
                    }
                }

                // let param1 = JSON.parse(item.param);
                // if (!param1.query) this.$router.push("/home" + param1.route);
                // else {
                //     this.$router.push({
                //         path: "/home" + param1.route,
                //         query: param1.query,
                //     });
                // }
                // // let param1 = item.param;
                // if (!param1.query) window.open(param1, "_blank");
                // else {
                //     this.$router.push({
                //         path: "/home" + param1.route,
                //         query: param1.query,
                //     });
                // }
                // this.ind = item.ordina - 1;
            }
            //关联CMS的情况下，我们按照默认模板进行渲染
            else {
                if (item.ordina === 1) this.$router.push("/home");
                else {
                    if (item.childList.length === 0) {
                        this.$router.push({
                            path: "/home/solution",
                            query: {
                                id: item.id,
                            },
                        });
                    } else {
                        this.$router.push({
                            path: "/home/solution",
                            query: {
                                id: item.id,
                                tagnum: item.childList[0].ordina,
                            },
                        });
                    }
                }
            }
        },
        // 用户点击二级导航
        secondClick(item) {
            if (!item.isCMS) {
                let param1 = JSON.parse(item.param);
                if (!param1.query) this.$router.push("/home" + param1.route);
                else {
                    this.$router.push({
                        path: "/home" + param1.route,
                        query: param1.query,
                    });
                }
            } else {
                let item1 = this.navList.find((qwe) => qwe.id === item.parent);
                let ID = item1.id;
                this.$router.push({
                    path: "/home/solution",
                    query: {
                        id: ID,
                        tagnum: item.ordina,
                    },
                });
            }
        },
        setClass(index) {
            if (index == this.index) {
                return "nav-item navactive";
            } else {
                return "nav-item";
            }
        },
        sortby(prop, rev = true) {
            return function (a, b) {
                var val1 = a[prop];
                var val2 = b[prop];
                return rev ? val1 - val2 : val2 - val1;
            };
        },
        async getNav() {
            await GMS.$http
                .get("/home/getNavigation")
                .then((res) => {
                    if (res.status == 200) {
                        //我们遍历对应数据，将此两层对象数组的数据存入navList
                        let data = res.data;
                        let navList = [];
                        let zfcgggParent = {};
                        let zfcggg = {};
                        let zfjggg = {};
                        let zfgzgg = {};
                        let xxtycgggParent = {};
                        let xxtycggg = {};
                        let xxtyjggg = {};
                        let xxtygzgg = {};
                        let xnzxcggg = {};
                        let xnzxjggg = {};
                        let xnzxgzgg = {};
                        let jjcgcggg = {};
                        let jjcgjggg = {};
                        let jjcggzgg = {};
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].title === "政府采购公告") {
                                zfcgggParent = data[i];
                            }
                            if (data[i].title === "政府采购公告-采购公告") {
                                zfcggg = data[i];
                            }
                            if (data[i].title === "政府采购公告-结果公告") {
                                zfjggg = data[i];
                            }
                            if (data[i].title === "政府采购公告-更正公告") {
                                zfgzgg = data[i];
                            }
                            if (data[i].title === "学校统一采购公告") {
                                xxtycgggParent = data[i];
                            }
                            if (data[i].title === "学校统一采购公告-采购公告") {
                                xxtycggg = data[i];
                            }
                            if (data[i].title === "学校统一采购公告-结果公告") {
                                xxtyjggg = data[i];
                            }
                            if (data[i].title === "学校统一采购公告-更正公告") {
                                xxtygzgg = data[i];
                            }
                            if (data[i].title === "校内自行采购公告-采购公告") {
                                xnzxcggg = data[i];
                            }
                            if (data[i].title === "校内自行采购公告-结果公告") {
                                xnzxjggg = data[i];
                            }
                            if (data[i].title === "校内自行采购公告-更正公告") {
                                xnzxgzgg = data[i];
                            }
                            if (data[i].title === "竞价采购-采购公告") {
                                jjcgcggg = data[i];
                            }
                            if (data[i].title === "竞价采购-结果公告") {
                                jjcgjggg = data[i];
                            }
                            if (data[i].title === "竞价采购-更正公告") {
                                jjcggzgg = data[i];
                            }
                            if (!data[i].parent) {
                                data[i].childList = [];
                                navList.push(data[i]);
                            }
                        }
                        let childList = data.filter((item) => {
                            return item.parent;
                        });
                        //为navList的子数组进行赋值
                        for (let i = 0; i < navList.length; i++) {
                            for (let j = 0; j < childList.length; j++) {
                                if (navList[i].id == childList[j].parent) {
                                    navList[i].childList.push(childList[j]);
                                }
                            }
                        }
                        navList.sort(this.sortby("ordina"));
                        this.navList = navList;
                        //存储对应的导航列表，保证首页各模块和详情页等其他组件可以动态获取对应的id值，保证对应的跳转。
                        sessionStorage.setItem("navList", JSON.stringify(navList));
                        console.log("获取导航列表成功", navList);
                        let cgyxgk = navList.find((value) => value.title == "采购意向公开");
                        let cgyxgkId = cgyxgk ? cgyxgk.cmsId : "";
                        let zggs = navList.find((value) => value.title == "自购公示");
                        let zggsId = zggs ? zggs.cmsId : "";
                        let inform = navList.find((value) => {
                            if (value.title === "信息公开") {
                                return value.cmsId;
                            }
                        });
                        let workProgress = navList.find((value) => {
                            if (value.title === "工作进度") {
                                return value.cmsId;
                            }
                        });
                        let worker = navList.find((value) => {
                            if (value.title === "政策法规") {
                                return value.cmsId;
                            }
                        });
                        let downloadCenter = navList.find((value) => {
                            if (value.title === "下载中心") {
                                return value.cmsId;
                            }
                        });
                        let gzdt = navList.find((value) => {
                            if (value.title === "工作动态") {
                                return value.cmsId;
                            }
                        });
                        let tzgg = navList.find((value) => {
                            if (value.title === "通知公告") {
                                return value.cmsId;
                            }
                        });
                        // 给首页的通知公告，办事指南，工作动态传值
                        GMS.vbus.$emit("getId", {
                            inform: inform ? inform.cmsId : true,
                            workProgressId: workProgress ? workProgress.cmsId : true,
                            workerId: worker ? worker.cmsId : true,
                            downloadCenterId: downloadCenter ? downloadCenter.cmsId : true,
                            gzdtId: gzdt ? gzdt.cmsId : true,
                            tzggId: tzgg ? tzgg.cmsId : true,
                            cgyxgkId: cgyxgkId,
                            zggsId: zggsId,
                            zfcgggParentId: zfcgggParent ? zfcgggParent.cmsId : "政府采购公告id",
                            zfcgggId: zfcggg ? zfcggg.cmsId : "政府采购公告-采购公告id",
                            zfjgggId: zfjggg ? zfjggg.cmsId : "政府采购公告-结果公告id",
                            zfgzggId: zfgzgg ? zfgzgg.cmsId : "政府采购公告-更正公告id",
                            xxtycgggParentId: xxtycgggParent ? xxtycgggParent.cmsId : "学校统一采购公告-采购公告id",
                            xxtycgggId: xxtycggg ? xxtycggg.cmsId : "学校统一采购公告-采购公告id",
                            xxtyjgggId: xxtyjggg ? xxtyjggg.cmsId : "学校统一采购公告-结果公告id",
                            xxtygzggId: xxtygzgg ? xxtygzgg.cmsId : "学校统一采购公告-更正公告id",
                            xnzxcgggId: xnzxcggg ? xnzxcggg.cmsId : "校内自行采购公告-采购公告id",
                            xnzxjgggId: xnzxjggg ? xnzxjggg.cmsId : "校内自行采购公告-结果公告id",
                            xnzxgzggId: xnzxgzgg ? xnzxgzgg.cmsId : "校内自行采购公告-更正公告id",
                            jjcgcgggId: jjcgcggg ? jjcgcggg.cmsId : "竞价采购-采购公告id",
                            jjcgjgggId: jjcgjggg ? jjcgjggg.cmsId : "竞价采购-结果公告id",
                            jjcggzggId: jjcggzgg ? jjcggzgg.cmsId : "竞价采购-更正公告id",
                        });
                        this.refreshNav();
                    }
                })
                .catch((error) => {
                    this.refreshNav();
                    GMS.vbus.$emit("getId", {
                        inform: 1,
                        guide: 2,
                        workerId: 3,
                    });
                    this.$Message.error("获取数据异常", error);
                });
        },
        cover(item) {
            if (item.childList.length > 0) {
                this.isNav = true;
                this.list = item.childList;
                this.title = item.title;
            }
        },
        clear() {
            this.isShow = false;
        },
        leave() {
            this.isNav = false;
        },
        enter() {
            this.isNav = true;
        },
        // 判断扩展导航是否展示
        decide() {
            if (this.navList.length > 6) {
                for (let i = 6; i < this.navList.length; i++) {
                    if (this.navList[i].isShow) {
                        this.isShow = true;
                        return true;
                    }
                    this.isShow = false;
                    return false;
                }
                this.isShow = false;
                return false;
            }
        },
        // 导航栏清单
        refreshNav() {
            let lis = refreshNav;
        },
        async getLogo() {
            await GMS.$http
                .get("/portal/logo/query")
                .then((res) => {
                    if (res.status == 200) {
                        if (res.data.content) {
                            this.imgLogo = res.data.content;
                            this.logoContent = false;
                        }
                        this.logoShow = true;
                    }
                })
                .catch((error) => {
                    this.logoShow = true;
                    this.$Message.error("获取数据异常，请联系管理员");
                });
        },
    },
};
</script>

<style lang="less" scoped>
.nav-lists {
    display: flex;
    align-items: center;
    position: relative;
    .search{
        position: absolute;
        right: -180px;
    }
}
.nav {
    width: 100%;
    height: 60px;
    background: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(218, 217, 217, 0.5);
    padding: 0 15%;
}
.nav-content {
    // width: 1200px;
}
// @media screen and (max-width: 1500px) {
//     .nav-content {
//         width: 1200px;
//     }
//     .nav-text {
//         margin-left: 16px !important;
//         margin-right: 16px !important;
//     }
// }
// @media screen and (min-width: 1500px) and (max-width: 1800px) {
//     .nav-content {
//         width: 1400px;
//     }
//     .nav-text {
//         margin-left: 36px !important;
//         margin-right: 36px !important;
//     }
// }
// @media screen and (min-width: 1800px) {
//     .nav-content {
//         width: 1600px;
//     }
//     .nav-text {
//         margin-left: 36px !important;
//         margin-right: 36px !important;
//     }
// }
.nav-content {
    margin: 0 auto;
}
.nav-item:hover .nav-down-wrap {
    opacity: 1;
}
.nav-item:hover .nav-down-wraps {
    opacity: 1;
}
.nav-item {
    flex: 1;
    height: 60px;
    position: relative;
    display: flex;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.89;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 18px;
    color: #0f0f0f;
    white-space: nowrap;
    .nav-down-wrap {
        width: 230px;
        background: #ffffff;
        position: absolute;
        top: 60px;
        left: 0;
        opacity: 0;
        z-index: 5;
        overflow: hidden;
        box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
    }
    .nav-down-wraps {
        width: 150px;
        background: #ffffff;
        position: absolute;
        top: 60px;
        left: -25px;
        opacity: 0;
        z-index: 5;
        overflow: hidden;
        box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
    }
    .down-item {
        cursor: pointer;
        height: 20px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #0f0f0f;
        line-height: 20px;
        text-indent: 20px;
        margin-top: 10px;
        margin-bottom: 10px;
        position: relative;
    }
    .dian {
        position: absolute;
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background: #23a9ff;
        top: 8px;
        left: 8px;
        opacity: 0;
    }
    .down-item:hover {
        font-size: 16px;
        color: #0081e9;
    }
    .down-item:hover .dian {
        opacity: 1;
    }
    .down-item:first-child {
        margin-top: 14px;
    }
    .nav-text {
        margin-left: 36px;
        margin-right: 34px;
        opacity: 0.89;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 18px;
        color: #0f0f0f;
        line-height: 60px;
    }
    .text {
        width: 30px;
        height: 30px;
        margin-top: 15px;
        margin-left: 16px;
        margin-right: 16px;
        background: url("../../static/img1/折叠.webp") no-repeat;
    }
}
.navactive {
    background: #e8b138;
    color: #ffffff;
    font-weight: 500;
    .nav-text {
        color: #ffffff;
    }
}

.nav-item:hover {
    background: #e8b138;
    color: #ffffff;
}
.nav-search {
    float: right;
    width: 246px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 18px;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
    letter-spacing: -0.15px;
    line-height: 36px;
    margin-top: 10px;
    text-indent: 15px;
}
.nav-logo {
    float: left;
    width: 297px;
    height: 41px;
    margin-top: 10px;
    margin-right: 130px;
    // background: url('../../static/img1/logo.webp') no-repeat;
}
.logo {
    object-fit: cover;
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue